function handleError(handleErr, e) {
  if (handleErr) {
    handleErr(e)
  }
}

export function doGet(url, handleRes, handleErr = null) {
  fetch(url, {credentials: 'include'})
    .then(res => {
      return res;
    })
    .then(
      obj => {
        if (obj.httpCode && obj.httpCode === 403) {
          window.parent.location.reload()
        } else {
          handleRes(obj)
        }
      },
      e => {
        handleError(handleErr)
      }
    )
}


export function doPost(url, data, handleRes, handleErr = null) {
  fetch(url, {
    method: 'post',
    body: JSON.stringify(data),
    credentials: 'include',
    headers: {'content-type': 'application/json;charset=UTF-8'}
  })
    .then(res => {
      return res;
    })
    .then(
      obj => {
        handleRes(obj)
      },
      e => {
        handleError(handleErr, e)
      }
    )
}

export function doPut(url, data, handleRes, handleErr = null) {
  fetch(url, {
    method: 'put',
    body: JSON.stringify(data),
    credentials: 'include',
    headers: {'content-type': 'application/json;charset=UTF-8'}
  })
    .then(res => {
      return res.json()
    })
    .then(
      obj => {
        handleRes(obj)
      },
      a => {
        handleError(handleErr, a)
      }
    )
}

export function doDel(url, data, handleRes, handleErr = null) {
  fetch(url, {
    method: 'delete',
    body: JSON.stringify(data),
    credentials: 'include',
    headers: {'content-type': 'application/json;charset=UTF-8'}
  })
    .then(res => {
      return res.json()
    })
    .then(
      obj => {
        handleRes(obj)
      },
      e => {
        handleError(handleErr, e)
      }
    )
}

export function showTip(info) {
  const model = document.getElementById('global-tip')
  model.innerHTML = info
  model.style.display = 'block'
  setTimeout(() => {
    model.style.display = 'none'
  }, 2000)
}

const CURR_LANG = "zh";

export function timeAge(time, lang = CURR_LANG) {
  if (!time) return ''
  if (!(time instanceof Date)) {
    if (/^\d+$/.test(time)) {
      time = parseInt(time)
    } else {
      time = (`${time}`).replace(/-/g, '/')
    }
    time = new Date(time)
  }
  lang = lang || CURR_LANG
  const target = time.valueOf()
  const now = new Date().valueOf()
  let diff = now - target
  diff = Math.floor(diff / 1000)
  let minutes = Math.floor(diff / 60),
    hours = Math.floor(diff / 3600),
    days = Math.floor(diff / (3600 * 24)),
    months = Math.floor(diff / (3600 * 24 * 30))
  if (minutes < 60) {
    return minutes + (lang === 'en_US' ? ' minutes ago' : '分钟前')
  } else if (hours < 24) {
    return hours + (lang === 'en_US' ? ' hours ago' : '小时前')
  } else if (days < 7) {
    return days + (lang === 'en_US' ? ' days ago' : '天前')
  } else if (days < 30) {
    return parseInt(days / 7) + (lang === 'en_US' ? ' weeks ago' : '周前')
  }
  return months + (lang === 'en_US' ? ' months ago' : '月前')

}

export function equalDate(date1, date2) {
  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  )
}
